import gql from 'graphql-tag';

export const queryForContactDropdown = gql`
  query queryForContactDropdown(
    $limit: Int
    $page: Int
    $query: ContactSortOrQuery
    $sort: ContactSortOrQuery
  ) {
    queryForContactDropdown(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        firstName
        lastName
      }
      totalRecords
    }
  }
`;
